export default hover => {
  let hoverMarkers = document.querySelectorAll('.goe-picnic-image_marker')
  let copyBlocks = document.querySelectorAll('.item-copy')

  hoverMarkers.forEach(marker => {
    marker.addEventListener('mouseover', e => {
      let val = parseInt(e.target.dataset.marker)

      hoverMarkers.forEach((marker, i) => {
        if (i + 1 === val) {
          marker.classList.add('active')
        } else {
          marker.classList.remove('active')
        }
      })
      copyBlocks.forEach((block, i) => {
        if (i + 1 === val) {
          block.classList.add('active')
        } else {
          block.classList.remove('active')
        }
      })
    })
  })

  // Timer function to cycle through hover states
  window.onload = () => {
    let index = 0
    setInterval(e => {
      let newMarker = hoverMarkers[index]
      let newBlock = copyBlocks[index]

      hoverMarkers.forEach(marker => marker.classList.remove('active'))
      copyBlocks.forEach(block => block.classList.remove('active'))
      newMarker.classList.add('active')
      newBlock.classList.add('active')

      // Using modulus allows the index to reset back to 0 after reaching end of array of markers
      index = (index + 1) % hoverMarkers.length
    }, 3000)
  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/the-great-outdoors-edit-hover-module.js